/* Kalmix custom code | File: assets/gt03-scenario-results.js | Version: 1024.5 */
(function () {
  'use strict';

  var DEFAULT_SAMPLES = [{"id": "GUIDE-K35E-A", "configuration": "1 Hz · RTK + DR", "color": "#22a95a"}, {"id": "GUIDE-K35E-B", "configuration": "1 Hz · RTK + DR", "color": "#0e5cb6"}, {"id": "GUIDE-K35E-C", "configuration": "1 Hz · RTK + DR", "color": "#ec7427"}];

  var COLORS = {};
  DEFAULT_SAMPLES.forEach(function (sample) { COLORS[sample.id] = sample.color; });

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function numberOrNull(value) {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function readFirst(object, keys) {
    if (!object || typeof object !== 'object') return null;
    for (var index = 0; index < keys.length; index += 1) {
      if (object[keys[index]] !== undefined && object[keys[index]] !== null && object[keys[index]] !== '') {
        return object[keys[index]];
      }
    }
    return null;
  }

  function normalizePercent(value) {
    var number = numberOrNull(value);
    return number === null ? null : number;
  }

  function formatMeters(value) {
    var number = numberOrNull(value);
    return number === null ? '—' : number.toFixed(3) + ' m';
  }

  function formatPercent(value) {
    var number = normalizePercent(value);
    return number === null ? '—' : number.toFixed(3) + '%';
  }

  function formatEpochs(value) {
    var number = numberOrNull(value);
    return number === null ? '—' : Math.round(number).toLocaleString('en-US') + ' ep';
  }

  function getSampleColor(sample, index) {
    return sample.color || COLORS[sample.id] || ['#22a95a', '#0e5cb6', '#ec7427'][index % 3];
  }

  function normalizeSamples(data) {
    var supplied = Array.isArray(data && data.samples) ? data.samples : [];
    if (!supplied.length) return DEFAULT_SAMPLES.slice();

    return supplied.map(function (sample, index) {
      var fallback = DEFAULT_SAMPLES[index] || {};
      if (typeof sample === 'string') {
        return {
          id: sample,
          configuration: fallback.configuration || '',
          color: COLORS[sample] || fallback.color
        };
      }
      return {
        id: sample.id || sample.sample_id || sample.name || fallback.id || ('Sample ' + (index + 1)),
        configuration: sample.configuration || sample.config || fallback.configuration || '',
        color: sample.color || COLORS[sample.id || sample.sample_id || sample.name] || fallback.color
      };
    });
  }

  function getScenario(data, key) {
    var scenarios = data && data.scenarios;
    if (Array.isArray(scenarios)) {
      return scenarios.find(function (scenario) {
        return scenario && String(scenario.key || scenario.id || '').toLowerCase() === String(key).toLowerCase();
      }) || null;
    }
    return scenarios && scenarios[key] ? scenarios[key] : null;
  }

  function getSampleResult(scenario, sampleId) {
    if (!scenario || !scenario.samples) return null;
    if (Array.isArray(scenario.samples)) {
      return scenario.samples.find(function (sample) {
        return sample && String(sample.id || sample.sample_id || sample.name || '') === String(sampleId);
      }) || null;
    }
    return scenario.samples[sampleId] || null;
  }

  function tierClass(row, index) {
    var tier = Math.max(1, Math.min(5, Number(row && row.tier) || index + 1));
    return 'gt-v2-scenario__tier-' + tier;
  }

  function rowClass(row, index) {
    if (row && (row.unavailable === true || String(row.tier || '').toLowerCase() === 'unavailable')) {
      return 'gt-v2-scenario__tier-unavailable';
    }
    return tierClass(row, index);
  }

  function normaliseRows(rows) {
    return Array.isArray(rows) ? rows.map(function (row) {
      var source = row || {};
      return {
        label: source.label || source.name || 'Untitled',
        epochs: readFirst(source, ['epochs', 'count', 'epoch_count']),
        percent: normalizePercent(readFirst(source, ['percent', 'pct', 'share_percent', 'share'])),
        tier: source.tier
      };
    }) : [];
  }

  function snapshotMarkup(samples, scenario) {
    return samples.map(function (sample, index) {
      var result = getSampleResult(scenario, sample.id) || {};
      var snapshot = result.snapshot || result.stats || result;
      var horizontal = readFirst(snapshot, ['horizontal_rms_m', 'horizontal_rms', 'h_rms_m', 'horizontal_error_m']);
      var vertical = readFirst(snapshot, ['vertical_rms_m', 'vertical_rms', 'v_rms_m', 'vertical_error_m']);
      var fixed = readFirst(snapshot, ['rtk_fixed_pct', 'fixed_pct', 'rtk_fixed_percent']);
      var under10cm = readFirst(snapshot, ['under_10cm_pct', 'below_10cm_pct', 'accuracy_under_10cm_pct', 'under_10_cm_pct']);
      var color = getSampleColor(sample, index);
      var status = result.status || '';
      var isNoFix = String(status).toLowerCase() === 'no fix';
      var isDr = String(status).toLowerCase() === 'dr';
      var isNotPublicComparable = isNoFix || result.not_public_comparable === true || String(result.public_display || '') === '—';

      return '<article class="gt-v2-scenario__snapshot">' +
        '<div class="gt-v2-scenario__sample-meta">' +
          '<div class="gt-v2-scenario__sample-name"><i style="background:' + escapeHtml(color) + '"></i>' + escapeHtml(sample.id) + '</div>' +
          (sample.configuration ? '<div class="gt-v2-scenario__sample-config">' + escapeHtml(sample.configuration) + '</div>' : '') +
          (status && !isDr && !isNotPublicComparable ? '<span class="gt-v2-scenario__sample-status">' + escapeHtml(status) + '</span>' : '') +
        '</div>' +
        '<div class="gt-v2-scenario__snapshot-metrics">' +
          '<div class="gt-v2-scenario__snapshot-value" data-label="H RMS"><strong>' + (isNotPublicComparable ? '—' : formatMeters(horizontal)) + '</strong></div>' +
          '<div class="gt-v2-scenario__snapshot-value" data-label="V RMS"><strong>' + (isNotPublicComparable ? '—' : formatMeters(vertical)) + '</strong></div>' +
          '<div class="gt-v2-scenario__snapshot-value" data-label="RTK Fixed"><strong>' + (isNotPublicComparable ? '—' : formatPercent(fixed)) + '</strong></div>' +
          '<div class="gt-v2-scenario__snapshot-value" data-label="&lt;10 cm"><strong>' + (isNotPublicComparable ? '—' : formatPercent(under10cm)) + '</strong></div>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  function tabsMarkup(samples, activeSampleId, panelId) {
    return samples.map(function (sample, index) {
      var active = sample.id === activeSampleId;
      return '<button id="' + escapeHtml(panelId + '-tab-' + index) + '" class="gt-v2-scenario__tab' + (active ? ' is-active' : '') + '" type="button" role="tab" aria-controls="' + escapeHtml(panelId) + '" aria-selected="' + active + '" tabindex="' + (active ? '0' : '-1') + '" data-scenario-sample-id="' + escapeHtml(sample.id) + '">' +
        '<i style="background:' + escapeHtml(getSampleColor(sample, index)) + '"></i>' + escapeHtml(sample.id) +
      '</button>';
    }).join('');
  }

  function distributionBar(label, rows) {
    if (!rows.length) {
      return '<div class="gt-v2-scenario__bar-row"><span class="gt-v2-scenario__bar-label">' + escapeHtml(label) + '</span><div class="gt-v2-scenario__bar gt-v2-scenario__bar--unavailable" title="Not reported for this scenario"></div></div>';
    }
    var segments = rows.map(function (row, index) {
      var share = Math.max(0, row.percent || 0);
      if (share === 0) return '';
      return '<span class="gt-v2-scenario__segment ' + rowClass(row, index) + '" style="--share:' + share.toFixed(5) + '%" title="' + escapeHtml(row.label) + ': ' + escapeHtml(formatPercent(row.percent)) + '"></span>';
    }).join('');

    return '<div class="gt-v2-scenario__bar-row"><span class="gt-v2-scenario__bar-label">' + escapeHtml(label) + '</span><div class="gt-v2-scenario__bar">' + segments + '</div></div>';
  }

  function distributionGroup(title, rows, emptyMessage) {
    if (!rows.length) {
      return '<section class="gt-v2-scenario__group"><h5>' + escapeHtml(title) + '</h5><div class="gt-v2-scenario__pending">' + escapeHtml(emptyMessage || 'Not reported for this scenario.') + '</div></section>';
    }
    return '<section class="gt-v2-scenario__group"><h5>' + escapeHtml(title) + '</h5>' + rows.map(function (row, index) {
      return '<div class="gt-v2-scenario__row"><i class="gt-v2-scenario__dot ' + rowClass(row, index) + '"></i><span>' + escapeHtml(row.label) + '</span><span>' + formatEpochs(row.epochs) + ' · ' + formatPercent(row.percent) + '</span></div>';
    }).join('') + '</section>';
  }

  function analysisMarkup(result) {
    if (!result) return '<div class="gt-v2-scenario__pending">Scenario data pending.</div>';
    var quality = normaliseRows(result.position_quality || result.positionQuality).filter(function (row) {
      return String(row.label).replace(/[\s_-]/g, '').toLowerCase() !== 'nofix';
    });
    var accuracy = normaliseRows(result.accuracy_range || result.accuracyRange);
    if (!quality.length && !accuracy.length) {
      return '<div class="gt-v2-scenario__status"><strong>' + escapeHtml(result.status || 'Scenario data pending.') + '</strong>' + (result.status_detail ? '<br>' + escapeHtml(result.status_detail) : '') + '</div>';
    }

    return distributionBar('Accuracy', accuracy) +
      distributionBar('Quality', quality) +
      '<div class="gt-v2-scenario__analysis-details">' +
        distributionGroup('Position quality', quality, result.status_detail) +
        distributionGroup('Accuracy range', accuracy, result.accuracy_note || result.status_detail) +
      '</div>';
  }

  function renderScenario(article, data, samples) {
    var key = article.getAttribute('data-scenario-key');
    var scenario = getScenario(data, key);
    var state = article._gtScenarioState || {};
    var hasActive = samples.some(function (sample) { return sample.id === state.activeSampleId; });
    state.activeSampleId = hasActive ? state.activeSampleId : samples[0].id;
    article._gtScenarioState = state;

    var snapshotTarget = article.querySelector('[data-gt-v2-scenario-snapshots]');
    var tabsTarget = article.querySelector('[data-gt-v2-scenario-tabs]');
    var bodyTarget = article.querySelector('[data-gt-v2-scenario-analysis-body]');
    if (!snapshotTarget || !tabsTarget || !bodyTarget) return;

    snapshotTarget.innerHTML = snapshotMarkup(samples, scenario);
    var panelId = article.id + '-analysis';
    tabsTarget.innerHTML = tabsMarkup(samples, state.activeSampleId, panelId);
    bodyTarget.id = panelId;
    bodyTarget.setAttribute('role', 'tabpanel');
    bodyTarget.tabIndex = 0;
    bodyTarget.setAttribute('aria-labelledby', panelId + '-tab-' + samples.findIndex(function (sample) { return sample.id === state.activeSampleId; }));
    bodyTarget.innerHTML = analysisMarkup(getSampleResult(scenario, state.activeSampleId));
  }

  function selectSample(root, article, sampleId, moveFocus) {
    if (!root._gtScenarioData || !article) return;
    var tabs = Array.prototype.slice.call(article.querySelectorAll('[data-scenario-sample-id]'));
    var selected = tabs.find(function (tab) { return tab.getAttribute('data-scenario-sample-id') === sampleId; });
    if (!selected) return;
    article._gtScenarioState = article._gtScenarioState || {};
    article._gtScenarioState.activeSampleId = sampleId;
    tabs.forEach(function (tab) {
      var active = tab === selected;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    var body = article.querySelector('[data-gt-v2-scenario-analysis-body]');
    body.setAttribute('aria-labelledby', selected.id);
    body.innerHTML = analysisMarkup(getSampleResult(getScenario(root._gtScenarioData, article.getAttribute('data-scenario-key')), sampleId));
    if (moveFocus) selected.focus();
  }

  function renderRoot(root, data) {
    var samples = normalizeSamples(data);
    root.querySelectorAll('[data-gt-v2-scenario]').forEach(function (article) {
      renderScenario(article, data, samples);
    });
    root._gtScenarioData = data;
    root._gtScenarioSamples = samples;
  }

  function bindRoot(root) {
    if (root.dataset.gtScenarioReady === 'true') return;
    root.dataset.gtScenarioReady = 'true';
    root.addEventListener('click', function (event) {
      var jumpLink = event.target.closest('.gt-v2-scenario-nav__card');
      if (jumpLink && root.contains(jumpLink)) {
        var destination = document.querySelector(jumpLink.getAttribute('href'));
        if (destination) {
          event.preventDefault();
          destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      var tab = event.target.closest('[data-scenario-sample-id]');
      if (!tab || !root.contains(tab) || !root._gtScenarioData) return;
      var article = tab.closest('[data-gt-v2-scenario]');
      if (!article) return;
      selectSample(root, article, tab.getAttribute('data-scenario-sample-id'), false);
    });
    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-scenario-sample-id]');
      if (!tab || !root.contains(tab)) return;
      var article = tab.closest('[data-gt-v2-scenario]');
      var tabs = Array.prototype.slice.call(article.querySelectorAll('[data-scenario-sample-id]'));
      var index = tabs.indexOf(tab);
      var next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      selectSample(root, article, tabs[next].getAttribute('data-scenario-sample-id'), true);
    });
  }

  function initialiseRoot(root) {
    if (!root || root.dataset.gtScenarioLoading === 'true') return;
    bindRoot(root);
    var source = root.getAttribute('data-scenario-data-url');
    if (!source) return;
    root.dataset.gtScenarioLoading = 'true';
    fetch(source, { credentials: 'omit', cache: 'force-cache' })
      .then(function (response) {
        if (!response.ok) throw new Error('Scenario JSON returned ' + response.status);
        return response.json();
      })
      .then(function (data) {
        renderRoot(root, data || {});
      })
      .catch(function (error) {
        root.querySelectorAll('[data-gt-v2-scenario-analysis-body]').forEach(function (body) {
          body.textContent = 'Scenario statistics could not be loaded. Please refresh the page.';
        });
        console.warn('[GT03] Unable to load scenario JSON.', error);
      })
      .finally(function () {
        root.dataset.gtScenarioLoading = 'false';
      });
  }

  function positiveNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function formatTime(value) {
    var seconds = Math.max(0, Math.floor(Number(value) || 0));
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainder = seconds % 60;
    return (hours ? String(hours) + ':' + String(minutes).padStart(2, '0') : String(minutes)) + ':' + String(remainder).padStart(2, '0');
  }

  function initialisePlayer(player) {
    if (!player || player.dataset.gtV2PlayerReady === 'true') return;
    player.dataset.gtV2PlayerReady = 'true';

    var video = player.querySelector('[data-gt-v2-scenario-video]');
    if (!video) return;

    var toggleButton = player.querySelector('[data-gt-v2-video-toggle]');
    var bigPlayButton = player.querySelector('[data-gt-v2-video-big-play]');
    var replayButton = player.querySelector('[data-gt-v2-video-replay]');
    var fullscreenButton = player.querySelector('[data-gt-v2-video-fullscreen]');
    var progress = player.querySelector('[data-gt-v2-video-progress]');
    var timeLabel = player.querySelector('[data-gt-v2-video-time]');
    var speedButtons = Array.prototype.slice.call(player.querySelectorAll('[data-gt-v2-video-speed-option]'));
    var nativeSpeed = positiveNumber(player.dataset.videoNativeSpeed, 1);
    var defaultSpeed = positiveNumber(player.dataset.videoDefaultSpeed, nativeSpeed);

    function buttonSpeed(button) {
      return positiveNumber(button && button.dataset.speedLabel, nativeSpeed);
    }

    function nearestSpeedButton(target) {
      return speedButtons.reduce(function (closest, button) {
        return Math.abs(buttonSpeed(button) - target) < Math.abs(buttonSpeed(closest) - target) ? button : closest;
      }, speedButtons[0] || null);
    }

    function activeSpeedButton() {
      return player.querySelector('[data-gt-v2-video-speed-option].is-active') || nearestSpeedButton(defaultSpeed);
    }

    function applySpeed(button) {
      if (!button) return;
      var effectiveSpeed = buttonSpeed(button);
      video.playbackRate = clamp(effectiveSpeed / nativeSpeed, 0.25, 4);
      speedButtons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateState() {
      var duration = Number(video.duration) || 0;
      var current = Number(video.currentTime) || 0;
      if (progress) {
        progress.max = duration;
        progress.value = current;
      }
      if (timeLabel) timeLabel.textContent = formatTime(current) + ' / ' + formatTime(duration);
      player.classList.toggle('is-playing', !video.paused && !video.ended);
      player.classList.toggle('is-paused', video.paused || video.ended);
      if (toggleButton) {
        var playing = !video.paused && !video.ended;
        toggleButton.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        var icon = toggleButton.querySelector('path');
        if (icon) icon.setAttribute('d', playing ? 'M6 5h4v14H6zm8 0h4v14h-4z' : 'M8 5v14l11-7z');
      }
    }

    function togglePlayback() {
      if (video.paused || video.ended) {
        applySpeed(activeSpeedButton());
        video.play().catch(function () { updateState(); });
      } else {
        video.pause();
      }
    }

    toggleButton && toggleButton.addEventListener('click', togglePlayback);
    bigPlayButton && bigPlayButton.addEventListener('click', togglePlayback);
    video.addEventListener('click', togglePlayback);
    replayButton && replayButton.addEventListener('click', function () {
      video.currentTime = 0;
      applySpeed(activeSpeedButton());
      video.play().catch(function () { updateState(); });
    });
    fullscreenButton && fullscreenButton.addEventListener('click', function () {
      var active = document.fullscreenElement || document.webkitFullscreenElement;
      if (active) {
        (document.exitFullscreen || document.webkitExitFullscreen || function () {}).call(document);
      } else {
        var request = player.requestFullscreen || player.webkitRequestFullscreen;
        if (request) {
          var fullscreenResult = request.call(player);
          if (fullscreenResult && fullscreenResult.catch) fullscreenResult.catch(function () {});
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      }
    });
    progress && progress.addEventListener('input', function () {
      var nextTime = Number(progress.value);
      if (Number.isFinite(nextTime)) {
        video.currentTime = nextTime;
        updateState();
      }
    });
    speedButtons.forEach(function (button) {
      button.addEventListener('click', function () { applySpeed(button); });
    });
    video.addEventListener('loadedmetadata', function () {
      applySpeed(activeSpeedButton());
      updateState();
    });
    ['timeupdate', 'play', 'pause', 'ended'].forEach(function (eventName) {
      video.addEventListener(eventName, updateState);
    });

    applySpeed(nearestSpeedButton(defaultSpeed));
    updateState();
  }

  function initialise(scope) {
    var target = scope || document;
    target.querySelectorAll('[data-gt-v2-scenarios]').forEach(initialiseRoot);
    target.querySelectorAll('[data-gt-v2-scenario-player]').forEach(initialisePlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
